import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const FadeIn = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "112%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHeader = ({ index, label, title, lead }) => (
  <div className="max-w-3xl">
    <FadeIn>
      <p className="font-mono text-sm font-medium uppercase tracking-[0.25em] text-emerald-400">
        {index} · {label}
      </p>
    </FadeIn>
    <FadeIn delay={0.1}>
      <h2 className="mt-5 font-display text-3xl font-bold tracking-tight text-slate-50 sm:text-4xl lg:text-5xl">
        {title}
      </h2>
    </FadeIn>
    {lead && (
      <FadeIn delay={0.2}>
        <p className="mt-6 text-base leading-relaxed text-slate-400 sm:text-lg">{lead}</p>
      </FadeIn>
    )}
  </div>
);
